import { Outlet } from 'react-router-dom';
import {
  AppSidebar,
  HrmTopBar,
  useGetNotifications,
  useNotificationSubscription,
} from '@/components/core';

type NotificationsData = {
  notifications: unknown[];
  unReadNotificationsCount: number;
  totalNotificationsCount: number;
};

export const MainLayout = () => {
  // The bell's unread dot updates live: new notifications refresh the query below.
  useNotificationSubscription();
  const { data: notificationsData } = useGetNotifications({
    Page: 0,
    PageSize: 10,
  });

  const notifications: NotificationsData = notificationsData ?? {
    notifications: [],
    unReadNotificationsCount: 0,
    totalNotificationsCount: 0,
  };

  return (
    // `fixed inset-0` pins the shell to the viewport, so the top bar never moves even when a gesture
    // reaches the document (scroll chaining, mobile toolbars). It also makes the shell the containing
    // block for absolutely positioned descendants (Radix's hidden form inputs, sr-only text, ...), so
    // they can't escape `overflow-hidden` and stretch the document.
    <div className="fixed inset-0 flex overflow-hidden bg-background">
      <AppSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <HrmTopBar notifications={notifications} />
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-background">
          {/* The page root is the scroll container and carries the page padding itself, so its scrollbar
              sits on the far right edge and the padding still gives room for anything drawn outside a
              child's box (focus rings, ring offsets, shadows), which `overflow-auto` would clip. */}
          <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col [&>*]:flex [&>*]:h-full [&>*]:min-h-0 [&>*]:min-w-0 [&>*]:flex-1 [&>*]:flex-col [&>*]:overflow-auto [&>*]:overscroll-contain [&>*]:p-4 [&>*]:hrm-scrollbar sm:[&>*]:p-6 2xl:[&>*]:p-8">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
